export class Organization {
    new: boolean
    name: string
}